export enum BankAccountApplicationStatusTypeEnum {
	IN_PROGRESS = "InProgress",
	COMPLETED = "Completed"
}
